"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyAgeGroupStatsToJSON = exports.SurveyAgeGroupStatsFromJSONTyped = exports.SurveyAgeGroupStatsFromJSON = exports.instanceOfSurveyAgeGroupStats = void 0;
var runtime_1 = require("../runtime");
var SurveyGroupStats_1 = require("./SurveyGroupStats");
/**
 * Check if a given object implements the SurveyAgeGroupStats interface.
 */
function instanceOfSurveyAgeGroupStats(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyAgeGroupStats = instanceOfSurveyAgeGroupStats;
function SurveyAgeGroupStatsFromJSON(json) {
    return SurveyAgeGroupStatsFromJSONTyped(json, false);
}
exports.SurveyAgeGroupStatsFromJSON = SurveyAgeGroupStatsFromJSON;
function SurveyAgeGroupStatsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ageRange': !(0, runtime_1.exists)(json, 'age_range') ? undefined : json['age_range'],
        'stats': !(0, runtime_1.exists)(json, 'stats') ? undefined : (0, SurveyGroupStats_1.SurveyGroupStatsFromJSON)(json['stats']),
    };
}
exports.SurveyAgeGroupStatsFromJSONTyped = SurveyAgeGroupStatsFromJSONTyped;
function SurveyAgeGroupStatsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'age_range': value.ageRange,
        'stats': (0, SurveyGroupStats_1.SurveyGroupStatsToJSON)(value.stats),
    };
}
exports.SurveyAgeGroupStatsToJSON = SurveyAgeGroupStatsToJSON;
